// Environment variables
declare const API_CORE_URL: string;
declare const API_CHAT_URL: string;
declare const API_AUTH_URL: string;
declare const API_MEMED_URL: string;
declare const API_SOCKET_URL: string;
declare const API_GOV_BR_URL: string;
declare const FEATURE_FLAGS: string;
declare const MEMED_SCRIPT_URL: string;
declare const DATA_DELETION_REDIRECTION: string;
declare const AMPLITUDE_API_KEY: string;
declare const RECAPTCHA_KEY: string;
declare const RECAPTCHA_URL: string;
declare const HEALTH_CENTER_ID_PIAUI: string;
declare const HEALTH_CENTER_ID_AMAPA: string;
declare const HEALTH_CENTER_ID_POVOS_DA_FLORESTA: string;
declare const HEALTH_CENTER_ID_AMAZONAS: string;
declare const HEALTH_CENTER_ID_IASEP: string;
declare const HEALTH_CENTER_ID_SAO_PAULO: string;
declare const HEALTH_CENTER_ID_ALAGOAS: string;
declare const APP_DOMAIN_URL: string;
declare const APP_PIAUI_DOMAIN_URL: string;
declare const APP_AMAPA_DOMAIN_URL: string;
declare const APP_AMAZONAS_DOMAIN_URL: string;
declare const APP_POVOS_DA_FLORESTA_DOMAIN_URL: string;
declare const APP_POVOS_DA_FLORESTA_DOMAIN_REACT_URL: string;
declare const APP_DOMAIN_REACT_URL: string;
declare const APP_PIAUI_DOMAIN_REACT_URL: string;
declare const APP_AMAPA_DOMAIN_REACT_URL: string;
declare const APP_AMAZONAS_DOMAIN_REACT_URL: string;
declare const APP_IASEP_DOMAIN_REACT_URL: string;
declare const APP_ALAGOAS_REACT_DOMAIN_URL: string;
declare const APP_IASEP_DOMAIN_URL: string;
declare const APP_SAO_PAULO_DOMAIN_URL: string;
declare const APP_ALAGOAS_DOMAIN_URL: string;
declare const SUPERSET_DOMAIN: string;
declare const SUPERSET_DASHBOARD_ID: string;
declare const AGORA_ENABLE_STT: string;
declare const AGORA_ENABLE_RECORD_AUDIO_STT: string;
declare const FIREBASE_API_KEY: string;
declare const FACEBOOK_APP_ID: string;
declare const GOOGLE_CLIENT_ID: string;
declare const CURRENT_ENVIRONMENT: string;
declare const SENTRY_DSN: string;

import { version } from '../../version.json';

console.log(`APP_VERSION = ${version}`);

export const commonEnvironment = {
  appVersion: version,
  currentEnvironment: CURRENT_ENVIRONMENT,
  environmentVariables: {
    apiUrl: API_CORE_URL || '',
    apiCoreUrl: (API_CORE_URL || '') + '/api/core/v1',
    apiChatUrl: (API_CHAT_URL || '') + '/api/chat/v3',
    apiAuthUrl: (API_AUTH_URL || '') + '/api/auth/v1',
    apiMemedUrl: (API_MEMED_URL || '') + '/api/memed/v1',
    apiSocketUrl: (API_SOCKET_URL || ''),
    apiGovBrUrl: API_GOV_BR_URL || '',
    featureFlags: (FEATURE_FLAGS && FEATURE_FLAGS.split(',')) || [],
    memedScriptUrl:
      MEMED_SCRIPT_URL ||
      'https://integrations.memed.com.br/modulos/plataforma.sinapse-prescricao/build/sinapse-prescricao.min.js',
    healthCenterIdPiaui: HEALTH_CENTER_ID_PIAUI || '',
    healthCenterIdAmapa: HEALTH_CENTER_ID_AMAPA || '',
    healthCenterIdAmazonas: HEALTH_CENTER_ID_AMAZONAS || '',
    healthCenterIdIasep: HEALTH_CENTER_ID_IASEP || '',
    healthCenterIdSaoPaulo: HEALTH_CENTER_ID_SAO_PAULO || '',
    healthCenterIdAlagoas: HEALTH_CENTER_ID_ALAGOAS || '',
    dataDeletionRedirection: DATA_DELETION_REDIRECTION || '',
    GATrackers: {
      GA_TRACKING_ID_PIAUI: 'G-V435Q9PLDX',
      GA_TRACKING_ID_AMAPA: 'G-XDC94071PD',
      GA_TRACKING_ID_SOS: 'G-WKPQ4FKW6D',
      GA_TRACKING_ID_POVOS_DA_FLORESTA: 'G-V435Q9PLDX',
      GA_TRACKING_ID_AMAZONAS: 'G-KDYDB4VRSB',
      GA_TRACKING_ID_IASEP: 'G-9V991C81Y5',
      GA_TRACKING_ID_SAO_PAULO: 'G-1234567890', // needs to be changed later
      GA_TRACKING_ID_ALAGOAS: 'G-9XM1CM7CLY',
    },
    amplitudeApiKey: AMPLITUDE_API_KEY || '',
    appDomainUrl: APP_DOMAIN_URL || '',
    appPiauiDomainUrl: APP_PIAUI_DOMAIN_URL || '',
    appAmapaDomainUrl: APP_AMAPA_DOMAIN_URL || '',
    appAmazonasDomainUrl: APP_AMAZONAS_DOMAIN_URL || '',
    appIasepDomainUrl: APP_IASEP_DOMAIN_URL || '',
    appSaoPauloDomainUrl: APP_SAO_PAULO_DOMAIN_URL || '',
    appAlagoasDomainUrl: APP_ALAGOAS_DOMAIN_URL || '',
    healthCenterIdPovosDaFloresta: HEALTH_CENTER_ID_POVOS_DA_FLORESTA || '',
    appPovosDaFlorestaDomainUrl: APP_POVOS_DA_FLORESTA_DOMAIN_URL || '',
    appAmazonasDomainReactUrl: APP_AMAZONAS_DOMAIN_REACT_URL || '',
    appIasepDomainReactUrl: APP_IASEP_DOMAIN_REACT_URL || '',
    appPovosDaFlorestaDomainReactUrl: APP_POVOS_DA_FLORESTA_DOMAIN_REACT_URL || '',
    appPiauiDomainReactUrl: APP_PIAUI_DOMAIN_REACT_URL || '',
    appAmapaDomainReactUrl: APP_AMAPA_DOMAIN_REACT_URL || '',
    appAlagoasDomainReactUrl: APP_ALAGOAS_REACT_DOMAIN_URL || '',
    appDomainReactUrl: APP_DOMAIN_REACT_URL || '',
    recaptchaKey: RECAPTCHA_KEY || '',
    recaptchaUrl: RECAPTCHA_URL || '',
    supersetDomain: SUPERSET_DOMAIN || '',
    supersetDashboardID: SUPERSET_DASHBOARD_ID || '',
    agoraEnableSTT: AGORA_ENABLE_STT || '',
    agoraEnableRecordAudioSTT: AGORA_ENABLE_RECORD_AUDIO_STT || '',
    sentryDsn: SENTRY_DSN || '',
  },
  firebaseConfig: {
    apiKey: FIREBASE_API_KEY || '',
    authDomain: 'ptmp-d43bd.firebaseapp.com',
    databaseURL: 'https://ptmp-d43bd.firebaseio.com',
    projectId: 'ptmp-d43bd',
    storageBucket: 'ptmp-d43bd.appspot.com',
    messagingSenderId: '247949406192',
    appId: '1:247949406192:web:80d3609eea69d844707735',
    measurementId: 'G-MFFMY6KYEB',
  },
  appIds: {
    googleClientId: GOOGLE_CLIENT_ID || '',
    facebookAppId: FACEBOOK_APP_ID || '',
    appleClientId: 'com.ptm.iSalut.service',
  },
  appKeys: {},
  privacyPolicyUrl: 'https://sos.portaltelemedicina.com.br/privacidade/',
  userAgreementUrl: 'https://sos.portaltelemedicina.com.br/termos-e-condicoes-gerais-de-uso/',
};
